import React, { useState } from 'react';
import OwlTalkBox from '../components/OwlTalkBox';
import Button from '../components/Button';
import { motion } from 'framer-motion';

const GroupStudy = () => {
  const [buzzed, setBuzzed] = useState(false);
  const [winner, setWinner] = useState('');

  const handleBuzz = () => {
    setBuzzed(true);
    setWinner('You!');
    setTimeout(() => {
      setBuzzed(false);
      setWinner('');
    }, 2000);
  };

  const user = JSON.parse(localStorage.getItem('user') || '{}');

  return (
    <motion.div
      className="w-full max-w-xl flex flex-col items-center bg-white/80 dark:bg-gray-800/80 rounded-3xl shadow-2xl p-8"
      initial={{ opacity: 0, y: 40, scale: 0.95 }}
      animate={{ opacity: 1, y: 0, scale: 1 }}
      transition={{ type: 'spring', stiffness: 300, damping: 24 }}
      whileHover={{ scale: 1.02, boxShadow: '0 8px 32px 0 rgba(0,0,0,0.18)' }}
      whileTap={{ scale: 0.98 }}
    >
      <h2 className="font-baloo text-3xl font-extrabold mb-4 text-blue-700 dark:text-blue-200">Group Study Room</h2>
      <OwlTalkBox text="Fastest finger first! Hit the buzzer!" />
      <Button animate className={`mt-8 text-2xl px-10 py-6 rounded-full font-extrabold shadow-lg transition-all duration-200 ${buzzed ? 'bg-green-400 dark:bg-green-700 scale-110' : 'bg-gradient-to-r from-pink-400 to-yellow-300 dark:from-blue-900 dark:to-yellow-700 hover:scale-105'}`} onClick={handleBuzz} disabled={buzzed}>
        {buzzed ? 'Buzzed!' : 'BUZZER'}
      </Button>
      {winner && <div className="font-inter mt-4 text-xl font-bold text-green-600 dark:text-green-300 animate-bounce">Winner: {winner}</div>}
    </motion.div>
  );
};

export default GroupStudy; 